import React from 'react';
import PropTypes from 'prop-types';
import { databaseContactWarning } from './shared';
import AddressFields from './address_fields';

export default function CompanyContactForm({
  accessibleDatabaseContacts = [],
  areFieldsRequired,
  company,
  displayName,
  persistAddress,
  onAddressChange,
  onFieldChange,
  onToggleAddressFields
}) {
  const alreadyHasAddress = !!company?.address?.id;

  return (
    <React.Fragment>
      {databaseContactWarning(accessibleDatabaseContacts, displayName)}
      <label className="w-100 form-group">
        Company name {areFieldsRequired && (<span className="text-danger">(Required)</span>)}
        <input
          className="form-control fw-normal mt-2"
          placeholder="Enter company name"
          type="text"
          value={company.name || ''}
          onChange={e => onFieldChange(e.target.value, 'name')}
        />
      </label>
      <label className="w-100 form-group">
        Email
        <input
          className="form-control fw-normal mt-2"
          placeholder="Enter email"
          type="email"
          value={company.email || ''}
          onChange={e => onFieldChange(e.target.value, 'email')}
        />
      </label>
      <label className="w-100 form-group">
        Phone Number
        <input
          className="form-control fw-normal mt-2 d-block"
          placeholder="Enter phone number"
          type="tel"
          value={company.phoneNumber || ''}
          onChange={e => onFieldChange(e.target.value, 'phoneNumber')}
        />
      </label>
      {!alreadyHasAddress && (
        <label className="w-100 panel panel-default p-3 d-flex mb-4 clickable">
          <input
            checked={persistAddress}
            className="mt-0 mr-2"
            type="checkbox"
            onChange={onToggleAddressFields}
          />
          Add Primary Address
        </label>
      )}

      <AddressFields address={company?.address || {}} showAddress={persistAddress} onChange={onAddressChange}/>
    </React.Fragment>
  );
}

CompanyContactForm.propTypes = {
  accessibleDatabaseContacts: PropTypes.array,
  areFieldsRequired: PropTypes.bool.isRequired,
  company: PropTypes.object.isRequired,
  displayName: PropTypes.string,
  persistAddress: PropTypes.bool.isRequired,
  onAddressChange: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onToggleAddressFields: PropTypes.func.isRequired
};
